// Login.js — email/password sign-in gate. Login only (no signup/reset/social — deferred).
// Rendered by the AuthGate in index.js when there is no Supabase session.
import React, { useState } from "react";
import { supabase } from "./supabaseClient";

export default function Login({ onShowSignup }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    if (signInError) setError(signInError.message);
    setLoading(false);
    // On success, AuthGate's onAuthStateChange flips session and renders the app.
  };

  const inputStyle = {
    width: "100%",
    height: "44px",
    boxSizing: "border-box",
    background: "#141414",
    border: "0.5px solid #2a2a2a",
    borderRadius: "8px",
    color: "#e0e0e0",
    fontSize: "14px",
    padding: "0 12px",
    marginBottom: "12px",
    outline: "none",
    fontFamily: "inherit",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#04040c", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <form
        onSubmit={handleLogin}
        style={{
          width: "100%",
          maxWidth: "360px",
          background: "rgba(22,22,22,0.82)",
          border: "0.5px solid rgba(255,255,255,0.08)",
          borderRadius: "12px",
          padding: "28px 24px",
        }}
      >
        <h1 style={{ color: "#e0e0e0", fontSize: "18px", fontWeight: 600, margin: "0 0 20px", textAlign: "center" }}>
          Sign in
        </h1>
        <input
          type="email"
          autoComplete="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          required
        />
        <input
          type="password"
          autoComplete="current-password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
          required
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            height: "44px",
            background: "#818cf8",
            border: "none",
            borderRadius: "8px",
            color: "#04040c",
            fontSize: "14px",
            fontWeight: 600,
            cursor: loading ? "default" : "pointer",
            opacity: loading ? 0.7 : 1,
            fontFamily: "inherit",
          }}
        >
          {loading ? "Signing in…" : "Log in"}
        </button>
        {error && (
          <div style={{ color: "#f97316", fontSize: "13px", marginTop: "12px", textAlign: "center" }}>
            {error}
          </div>
        )}
        <button
          type="button"
          onClick={onShowSignup}
          style={{ width: "100%", marginTop: "14px", background: "none", border: "none", color: "#818cf8", fontSize: "13px", cursor: "pointer", fontFamily: "inherit" }}
        >
          Need an account? Sign up
        </button>
      </form>
    </div>
  );
}
